import { create } from 'zustand';
import { DrugItem } from 'src/api/types';
import { mountStoreDevtool } from 'simple-zustand-devtools';

interface State {
  setTopDrugsList: (topDrugsList: DrugItem[]) => void;
  topDrugsList: DrugItem[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const useTopDrugsStore = create<State>()((set) => ({
  setTopDrugsList: async (list) => {
    set({ topDrugsList: list });
  },
  topDrugsList: [],
  isLoading: false,
  setIsLoading: async (isLoading) => {
    set({ isLoading });
  }
}));

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('TopDrugsStore', useTopDrugsStore);
}

export default useTopDrugsStore;
